import { BreakdownDataProps } from "@/shared/components/Chart/chartUtils";
import { ChannelData, ChannelDataWithSourceAndTotal } from "@/shared/types";

export const MAX_INSUFFICIENT_SAMPLE_SIZE = 3;
export const NO_SAMPLE_SIZE = 0;

// A sufficient sample size is greater than 3
export const isAboveSampleSizeThreshold = (sampleSize: number) =>
  sampleSize > MAX_INSUFFICIENT_SAMPLE_SIZE;

// An insufficient sample size is 3 or less
export const isBelowSampleSizeThreshold = (sampleSize: number) =>
  sampleSize <= MAX_INSUFFICIENT_SAMPLE_SIZE;

export const filterEmptyData = (combinedROI: ChannelDataWithSourceAndTotal[]) => {
  return combinedROI.filter((data) => {
    const totalSpend = Object.values(data.spend).reduce((acc, value) => acc + value, 0);
    const totalRevenue = Object.values(data.revenue).reduce((acc, value) => acc + value, 0);
    return totalSpend !== 0 && totalRevenue !== 0;
  });
};

export const isInsufficientSampleSize = (item: ChannelData | BreakdownDataProps) => {
  const totalSampleSize = Object.values(item.sampleSize).reduce((acc, size) => acc + size, 0);
  return isBelowSampleSizeThreshold(totalSampleSize);
};
